import { loadStripe, Stripe } from "@stripe/stripe-js";

export type StripeEnv = "sandbox" | "live";

const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as string | undefined;

function deriveEnvironment(token: string | undefined): StripeEnv {
  if (token?.startsWith("pk_test_")) return "sandbox";
  if (token?.startsWith("pk_live_")) return "live";
  // Fail loud in dev rather than silently routing to live with a bad token
  if (import.meta.env.DEV) {
    console.error(
      "[stripe] VITE_PAYMENTS_CLIENT_TOKEN is missing or has an unrecognized prefix. " +
        "Expected pk_test_ (sandbox) or pk_live_ (live). Defaulting to sandbox."
    );
    return "sandbox";
  }
  // In production, refuse to assume — surface as live so a misconfigured
  // preview never accidentally writes against live keys.
  return "live";
}

const environment: StripeEnv = deriveEnvironment(clientToken);

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    if (!clientToken) {
      throw new Error("VITE_PAYMENTS_CLIENT_TOKEN is not set");
    }
    stripePromise = loadStripe(clientToken);
  }
  return stripePromise;
}

export function getStripeEnvironment(): StripeEnv {
  return environment;
}

export function isPaymentsTestMode(): boolean {
  return environment === "sandbox";
}
